// extracted by mini-css-extract-plugin
module.exports = {"root":"CompletedIcon_root__1Dp-p"};